import React, { Component } from "react";
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import { Helmet } from "react-helmet";
import Swal from "sweetalert2";
import emailjs from "@emailjs/browser";

// 🔐 EmailJS Credentials
const SERVICE_ID = "YOUR_SERVICE_ID";
const TEMPLATE_ID = "YOUR_TEMPLATE_ID";
const PUBLIC_KEY = "YOUR_PUBLIC_KEY";

class ContactUs extends Component {
  state = {
    name: "",
    email: "",
    phone: "",
    company: "",
    message: "",
    loading: false,
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const { name, email, phone, company, message } = this.state;

    if (!name || !email || !phone || !message) {
      Swal.fire("Missing Information", "Please fill all required fields.", "warning");
      return;
    }

    this.setState({ loading: true });

    const templateParams = {
      name,
      email,
      phone,
      company,
      message,
    };

    emailjs
      .send(SERVICE_ID, TEMPLATE_ID, templateParams, PUBLIC_KEY)
      .then(() => {
        Swal.fire(
          "Message Sent!",
          "Thank you for contacting us. We will get back to you shortly.",
          "success"
        );

        this.setState({
          name: "",
          email: "",
          phone: "",
          company: "",
          message: "",
          loading: false,
        });
      })
      .catch((error) => {
        console.error(error);
        Swal.fire(
          "Error",
          "Failed to send message. Please try again later.",
          "error"
        );
        this.setState({ loading: false });
      });
  };

  render() {
    const { name, email, phone, company, message, loading } = this.state;

    return (
      <>
        <Helmet>
          <title>Contact EBS Software Solution | India</title>
        </Helmet>

        <Container className="py-5">
          <Row className="mb-4 text-center">
            <Col>
              <h2 style={{ fontWeight: 800 }}>Contact Us</h2>
              <p>Let’s discuss your software requirements</p>
            </Col>
          </Row>

          <Row>
            <Col lg={6} className="mb-4">
              <Card className="shadow-sm border-0">
                <Card.Body>
                  <Form onSubmit={this.handleSubmit}>
                    <Form.Group className="mb-3">
                      <Form.Label>Name *</Form.Label>
                      <Form.Control name="name" value={name} onChange={this.handleChange} />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>Email *</Form.Label>
                      <Form.Control type="email" name="email" value={email} onChange={this.handleChange} />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>Phone *</Form.Label>
                      <Form.Control name="phone" value={phone} onChange={this.handleChange} />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>Company</Form.Label>
                      <Form.Control name="company" value={company} onChange={this.handleChange} />
                    </Form.Group>

                    <Form.Group className="mb-4">
                      <Form.Label>Message *</Form.Label>
                      <Form.Control as="textarea" rows={4} name="message" value={message} onChange={this.handleChange} />
                    </Form.Group>

                    <Button type="submit" className="w-100" disabled={loading}>
                      {loading ? "Sending..." : "Send Message"}
                    </Button>
                  </Form>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={6}>
              <Card className="shadow-sm border-0 h-100">
                <Card.Body>
                  <h5>EBS Software Solution</h5>
                  <p>
                    EBS IT Park,Near Uttar Banga Sambad Press,Madhya Shanti Nagar <br />
                    Siliguri,Jalpaiguri West Bengal – 734004
                  </p>
                  <p>
                    📞 +91 353 405 5548<br />
                    ✉ info@ebssoftware.co.in
                  </p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}

export default ContactUs;
